module.exports = __webpack_public_path__ + "static/d0259e14451ce0ddb8b56429bf878bb20e6a344c93e5751dccfbc703fd1a2e76-60d7f36c4d2bb9166508a94729e0457b.png";